"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var useStyles_1 = __importDefault(require("../useStyles"));
var useDialogContentClasses = function (contentClasses) {
    if (contentClasses === void 0) { contentClasses = {}; }
    var classes = (0, useStyles_1.default)();
    var dialogContentClasses = (0, react_1.useMemo)(function () {
        var _a;
        return (__assign(__assign({}, contentClasses), { dividers: (0, classnames_1.default)((_a = {},
                _a[contentClasses.dividers] = !!contentClasses.dividers,
                _a[classes.contentDividers] = true,
                _a)) }));
    }, [
        contentClasses,
        classes
    ]);
    return dialogContentClasses;
};
exports.default = useDialogContentClasses;
